type EmptyStateProps = {
  briefingsEmptyHeading: string;
  briefingsEmptyDescription: string;
};

const EmptyState = ({
  briefingsEmptyHeading,
  briefingsEmptyDescription,
}: EmptyStateProps) => {
  return (
    <div
      className="text-black-rock mb-[70px] mt-[40px] w-full bg-[#E8E8EB] px-3 py-4 text-center"
      data-testid="briefings-empty-state"
    >
      <h3 className="text-black-rock mb-[10px] font-bold text-[16px]">
        {briefingsEmptyHeading}
      </h3>

      <p className="m-auto max-w-[600px] text-[16px] text-mono-70">
        {briefingsEmptyDescription}
      </p>
    </div>
  );
};

export default EmptyState;
